<template>
  <v-data-iterator
    :items="groups.data"
    :page.sync="c_page"
    :items-per-page.sync="c_size"
    :server-items-length="groups.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-group-card
        v-for="(group, index) in slot.items"
        :group="group"
        :key="index"
        @edit="$emit('edit', group.id)"
      />
    </template>
  </v-data-iterator>
</template>

<script>

  export default {

    components: {
      'im-group-card': () => import('@/components/HotelGroups/GroupCard')
    },

    props: {
      groups: null,
    },

    data: () => ({
      pagination: {
        page: 1,
        size: 10,
      },
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    computed: {
      c_page: {
        get() {
          return this.pagination.page;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: val,
            size: this.pagination.size,
          })
        }
      },
      c_size: {
        get() {
          return this.pagination.size;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: this.pagination.page,
            size: val
          })
        }
      }
    }

  }

</script>